export const costCodeCellStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const negativeValueStyles = {
  color: 'error.main',
};
